// Data handler for lite version - no authentication required

export const loadQuestions = async () => {
  try {
    console.log('Loading questions from API...');
    // Load questions from the API endpoint that serves from /output folder
    const response = await fetch('/api/questions');
    console.log('API response status:', response.status);
    
    if (!response.ok) {
      throw new Error(`Failed to load questions: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log('API response data:', data);
    console.log('Number of questions loaded:', data.aiMaturityQuestions?.length || 0);
    
    if (!data.aiMaturityQuestions || data.aiMaturityQuestions.length === 0) {
      throw new Error('No questions found in API response');
    }
    
    return data.aiMaturityQuestions;
  } catch (error) {
    console.error('Error loading questions:', error);
    // Instead of fallback, throw the error so the app can handle it properly
    throw new Error(`Failed to load questions: ${error.message}`);
  }
};

export const checkExistingResponse = async (userName, companyName) => {
  try {
    const response = await fetch('/api/responses/check', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userName, companyName }),
    });
    
    if (response.ok) {
      const result = await response.json();
      return result.exists ? result : null;
    } else if (response.status === 429) {
      // Rate limit exceeded
      const error = await response.json();
      throw new Error(error.message || 'Rate limit exceeded');
    }
    
    return null;
  } catch (error) {
    console.error('Error checking existing response:', error);
    // Re-throw rate limit errors so they can be handled by the UI
    if (error.message.includes('Rate limit') || error.message.includes('administrator')) {
      throw error;
    }
    return null;
  }
};

export const saveResponse = async (userInfo, questions, responses, isPartialSave = false) => {
  try {
    // Prepare response data - convert from our internal key format back to the expected format
    const responseData = questions.map(question => {
      const questionKey = `${question.category}|||${question.question}`;
      return {
        order: question.order,
        category: question.category,
        question: question.question,
        employeeResponse: responses[questionKey] || null
      };
    });

    const response = await fetch('/api/responses/save', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        userInfo, 
        responses: responseData,
        isPartialSave
      }),
    });
    
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to save response');
    }
  } catch (error) {
    console.error('Error saving response:', error);
    throw error;
  }
};
export const checkAssessmentAvailability = async () => {
  try {
    const response = await fetch('/api/assessment-available');
    
    if (response.ok) {
      const result = await response.json();
      return { available: true, ...result };
    } else if (response.status === 429) {
      const error = await response.json();
      return { 
        available: false, 
        message: error.message || 'Your administrator has temporarily blocked this feature. Please contact info@thedewpointgroup.com to enable this feature.'
      };
    } else {
      return { 
        available: false, 
        message: 'Assessment is temporarily unavailable. Please contact info@thedewpointgroup.com for assistance.'
      };
    }
  } catch (error) {
    console.error('Error checking assessment availability:', error);
    return { 
      available: false, 
      message: 'Unable to verify assessment availability. Please contact info@thedewpointgroup.com for assistance.'
    };
  }
};

export const checkRateLimit = async () => {
  try {
    console.log('Checking rate limit...');
    const response = await fetch('/api/check-rate-limit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    });
    
    console.log('Rate limit response status:', response.status);
    
    if (response.ok) {
      const result = await response.json();
      console.log('Rate limit check passed:', result);
      return { allowed: true, ...result };
    } else {
      const error = await response.json();
      console.log('Rate limit check failed:', error);
      return { 
        allowed: false, 
        message: error.message || 'Assessment is temporarily unavailable. Please contact info@thedewpointgroup.com for assistance.',
        ...error 
      };
    }
  } catch (error) {
    console.error('Error checking rate limit:', error);
    return { 
      allowed: false, 
      error: 'Unable to check rate limit',
      message: 'Unable to verify assessment availability. Please try again or contact info@thedewpointgroup.com for assistance.'
    };
  }
};

export const generateReport = async (userInfo, contactInfo) => {
  try {
    const response = await fetch('/api/generate-report', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userInfo, contactInfo }),
    });
    
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to generate report');
    }
  } catch (error) {
    console.error('Error generating report:', error);
    throw error;
  }
};